import React, { FC, memo } from 'react'
import { Collapse } from 'antd'
import { useIntl } from 'react-intl'

const { Panel } = Collapse

const RegistryProblems: FC = () => {
    const intl = useIntl()

    return (
        <div>
            <Collapse accordion bordered={false} expandIconPosition="right" className="landing-page-faq-collapse">
                <Panel
                    header="我的观看码可以分享给其他人吗？"
                    key="1"
                    className="landing-page-faq-collapse-header"
                >
                    <p>一个观看码仅限一个装置 / 浏览器登录，若您分享给其他人使用，您本人则无法观看本次直播。</p>
                </Panel>
                <Panel
                    header="如何观看回放？哪里可以获得直播课件？"
                    key="2"
                    className="landing-page-faq-collapse-header"
                >
                    <p>您将在直播结束后的第 7 个工作日收到「直播精彩回顾邮件」，内含：直播完整回放、直播课件、直播回放精彩剪辑以及相关主题的实操手册等资源。</p> 
                </Panel>
                <Panel
                    header="参与直播互动后，如何知道自己中奖？ 中奖后，礼品多久寄到？"
                    key="3"
                    className="landing-page-faq-collapse-header"
                >
                    <div className="landing-page-faq-collapse-box">
                        <p style={{ display: 'block' }}>
                        中奖名单将在直播时，公布在聊天区。
                        </p>
                        <p style={{ display: 'block' }}>
                        直播结束后，我们将在 7 个工作日内发送中奖邮件到您的报名邮箱。届时请回复寄送信息，工作人员会尽快为您安排投递。                        </p>
                    </div>
                </Panel> 
            </Collapse>
        </div>
    )
}

export default memo(RegistryProblems)
